import React, { ReactNode } from 'react'
import { useFlag } from '@afterpaytouch/feature'
import { useTranslation } from 'next-i18next'
import { Head, ConsumerLendingSummary } from '../../../src/component'
import { TrackOnMount } from '../../../src/integrations/monitoring'
import { TrackingEvent } from '../../../src/model/monitoring'
import { CheckoutPage, Features, PayMonthlyRedesignRollout } from '../../../src/model'
import { ConsumerLendingSummaryGA } from '../../component/ConsumerLendingSummaryGA'

export const ConsumerLendingSummaryPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const redesignRollout = useFlag<PayMonthlyRedesignRollout>(Features.CHECKOUT_PAY_MONTHLY_REDESIGN_ROLLOUT, PayMonthlyRedesignRollout.DEFAULT)
  const pageTitle = `${t('summary:reviewOrder')} | ${t('common:brandName')}`

  const renderSummary = (): ReactNode => {
    if (redesignRollout === PayMonthlyRedesignRollout.GA) {
      return <ConsumerLendingSummaryGA />
    }

    return <ConsumerLendingSummary />
  }

  return (
    <>
      <Head title={pageTitle} />
      {renderSummary()}
      <TrackOnMount eventName={TrackingEvent.VIEWED_SUMMARY_PAGE} />
    </>
  )
}
